<!--
 * @Date: 2025-02-13 10:04:18
 * @LastEditors: furan NgeKaworu@gmail.com
 * @LastEditTime: 2025-05-08 16:11:10
 * @FilePath: /newwork-h5/src/views/setting/index.vue
-->
<template>
  <div class="setting">
    <NavBar :narBarTitle="$t('设置')" />
    <div class="setting-card">
      <div>{{ $t('账号') }}</div>
      <div>{{ username }}</div>
    </div>
    <div class="setting-card" @click="toUpdatePwd">
      <div>{{ $t('修改密码') }}</div>
      <van-icon name="arrow" color="#999999" />
    </div>
    <div class="logout" @click="logout">{{ $t('退出登录') }}</div>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import Vue from 'vue'
import { Icon } from 'vant'
import { LocaleMgr } from 'i18n'

Vue.use(Icon)
export default {
  name: 'Setting',
  components: {
    NavBar,
  },
  data() {
    return {
      username: '',
      user: {},
    }
  },
  methods: {
    toUpdatePwd() {
      this.$router.push('/changePwd')
    },
    logout() {
      localStorage.removeItem('user')
      let companyCode = { code: JSON.parse(localStorage.getItem('cCode')).code }
      localStorage.setItem('companyCode', JSON.stringify(companyCode))
      localStorage.setItem('ifLogout', JSON.stringify(true))
      localStorage.removeItem('cCode')
      localStorage.removeItem('userLanguage')
      localStorage.removeItem('enterpriseLanguage')
      LocaleMgr.singleton.setLocale()
      this.$router.replace('/login')
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.username = this.user.username
  },
}
</script>
<style lang="less" scoped>
.setting {
  height: 100%;
  background: #f6f6f6;

  .setting-card {
    height: 56px;
    padding: 0px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    background: #fefffe;
    font-size: 16px;
    line-height: 24px;
  }

  .logout {
    height: 24px;
    font-size: 16px;
    font-weight: 500;
    color: #ff7875;
    line-height: 24px;
    position: absolute;
    bottom: 124px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
